"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CartViewPanelProps_1 = require("./CartViewPanelProps");
var styles = require("./CartViewPanel.scss");
var icons = require("../../../styles/ccc-icons-cart.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var localdatastore_1 = require("../../../config/localdatastore");
var Api_1 = require("../../../api/Api");
var LegalAPI_1 = require("../../../api/LegalAPI");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var Utils = require("../../../utils/UtilityFunctions");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartZipEdit_1 = require("../../CartLob/shared/CartZipEdit/CartZipEdit");
var cartUtils = require("../../../utils/CartUtilFunctions");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var components_1 = require("@idp/duc/components");
var MonthlySavings_1 = require("../../CartLob/shared/MonthlySavings");
var CartCommonStyle = require("../../../styles/CartCommon.scss");
var CartViewPanel = /** @class */ (function (_super) {
    __extends(CartViewPanel, _super);
    function CartViewPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.due1stBillModalLegalObj = {};
        _this.dueMonthlyModalLegalObj = {};
        _this.dueTodayModalLegalObj = {};
        _this.EditText = 'Edit ';
        _this.RemoveText = 'Remove';
        _this.ExpandText = 'Expand ';
        _this.CollapseText = 'Collapse ';
        _this.isEarlyUpgrade = false;
        _this.eapFlowContext = { isEAPFlow: false, eapFlowType: '' };
        _this.isCommonCart = false;
        _this.pricingType = PriceContainerProps_1.PricingType.XSMALL;
        _this.state = {
            accordianOpen: true,
            due1stBillModalDisplayed: false,
            dueMonthlyModalDisplayed: false,
            dueTodayModalDisplayed: false,
            isBundleCart: false,
            legalContenFound: false,
        };
        _this.openDueTodayModal = _this.openDueTodayModal.bind(_this);
        _this.closeDueTodayModal = _this.closeDueTodayModal.bind(_this);
        _this.openDueMonthlyModal = _this.openDueMonthlyModal.bind(_this);
        _this.closeDueMonthlyModal = _this.closeDueMonthlyModal.bind(_this);
        _this.openDue1stBillModal = _this.openDue1stBillModal.bind(_this);
        _this.closeDue1stBillModal = _this.closeDue1stBillModal.bind(_this);
        _this.openRemoveItemModal = _this.openRemoveItemModal.bind(_this);
        _this.handleCommonCartModal = _this.handleCommonCartModal.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.getDueTodaySubSecView = _this.getDueTodaySubSecView.bind(_this);
        _this.api = new Api_1.default();
        _this.legalApi = new LegalAPI_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.getDueTodayModal = _this.getDueTodayModal.bind(_this);
        _this.dueTodaySubSection = _this.dueTodaySubSection.bind(_this);
        _this.dueMonthlySection = _this.dueMonthlySection.bind(_this);
        _this.dueOnFirstBillSection = _this.dueOnFirstBillSection.bind(_this);
        _this.externalOrderSourceDueView = _this.externalOrderSourceDueView.bind(_this);
        _this.bauDueView = _this.bauDueView.bind(_this);
        return _this;
    }
    Object.defineProperty(CartViewPanel.prototype, "ariaLabelContent", {
        get: function () {
            return " " + this.props.data.lineOfBusinessName + ", " + (this.props.options.accessibility || '');
        },
        enumerable: false,
        configurable: true
    });
    CartViewPanel.prototype.componentDidMount = function () {
        if (this.props.data.due1stBillModalLegalContents && this.props.data.due1stBillModalLegalContents.legalModalPath) {
            this.getLegalIDPContent(this.props.data.due1stBillModalLegalContents.legalModalPath, this.due1stBillModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONFIRSTBILL, this.props.data.due1stBillModalLegalContents.legallinkText, this.props.data.due1stBillModalLegalContents.shortText);
        }
        else {
            this.getLegalContent(this.props.data.due1stBillModalLegalUrl, this.due1stBillModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONFIRSTBILL);
        }
        if (this.props.data.dueMonthlyModalLegalContents && this.props.data.dueMonthlyModalLegalContents.legalModalPath) {
            this.getLegalIDPContent(this.props.data.dueMonthlyModalLegalContents.legalModalPath, this.dueMonthlyModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONMOTHLY, this.props.data.dueMonthlyModalLegalContents.legallinkText, this.props.data.dueMonthlyModalLegalContents.shortText);
        }
        else {
            this.getLegalContent(this.props.data.dueMonthlyModalLegalUrl, this.dueMonthlyModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONMOTHLY);
        }
        if (this.props.data.dueTodayModalLegalContents && this.props.data.dueTodayModalLegalContents.legalModalPath) {
            this.getLegalIDPContent(this.props.data.dueTodayModalLegalContents.legalModalPath, this.dueTodayModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONTODAY, this.props.data.dueTodayModalLegalContents.legallinkText, this.props.data.dueTodayModalLegalContents.shortText);
        }
        else {
            this.getLegalContent(this.props.data.dueTodayModalLegalUrl, this.dueTodayModalLegalObj, CartViewPanelProps_1.LegalTypes.DUEONTODAY);
        }
        this.setState({
            accordianOpen: !Utils.isBundleinCart().isBundleWithoutDTVNorAccessory || !this.props.options.showAccordions,
            isBundleCart: Utils.isBundleinCart().isBundleWithoutDTVNorAccessory,
        });
        this.eapFlowContext = cartUtils.getEAPDetails();
    };
    CartViewPanel.prototype.openDueTodayModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('See details', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_TODAY_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_TODAY_MODAL);
        this.setState({ dueTodayModalDisplayed: true });
    };
    CartViewPanel.prototype.closeDueTodayModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_TODAY_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ dueTodayModalDisplayed: false });
    };
    CartViewPanel.prototype.openDueMonthlyModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('See details', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_MONTHLY_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_MONTHLY_MODAL);
        this.setState({ dueMonthlyModalDisplayed: true });
    };
    CartViewPanel.prototype.closeDueMonthlyModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_MONTHLY_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ dueMonthlyModalDisplayed: false });
    };
    CartViewPanel.prototype.openDue1stBillModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('See details', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_1STBILL_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_1STBILL_MODAL);
        this.setState({ due1stBillModalDisplayed: true });
    };
    CartViewPanel.prototype.closeDue1stBillModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_1STBILL_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ due1stBillModalDisplayed: false });
    };
    CartViewPanel.prototype.handleCommonCartModal = function (modalOperation, linkText) {
        this.reportingService.fireLinkClickWithOutPageLoad(linkText, ReportingService_1.PageUrls.CART_PAGE);
        if (modalOperation) {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_TODAY_MODAL);
        }
        else {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        }
        this.setState({ showCommonLegal: modalOperation });
    };
    CartViewPanel.prototype.getMonthlyText = function () {
        return this.props.data.dueMonthlyLabel ? this.props.data.dueMonthlyLabel : 'Due monthly';
    };
    CartViewPanel.prototype.openRemoveItemModal = function () {
        this.props.events.onRemove();
    };
    CartViewPanel.prototype.render = function () {
        var _a, _b;
        var iconClasses = __spreadArrays([icons.cccIconCart, icons.cccIconCartLg], this.getIconFromOps(this.props.options));
        var imageUrl = 'https://www.att.com/idpassets/global/icons/svg/devices/pictogram_devices-2_96.svg';
        this.pricingType = (window.innerWidth < 768) ? PriceContainerProps_1.PricingType.XSMALL : PriceContainerProps_1.PricingType.SMALL;
        var orderSubType = Utils.getOrderSubType();
        var isActivationFlow = !!(orderSubType &&
            ((orderSubType.toUpperCase().indexOf('ACTIVATION') > -1)));
        var displayRemoveLink = !Utils.isLoginRequiredonCart() &&
            !Utils.isBMWFlow() && !isActivationFlow;
        var isFBmarketing = false;
        var channeltype = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'channeltype');
        if (channeltype && channeltype.type && channeltype.type === 'fbmarketing') {
            isFBmarketing = true;
        }
        this.isCommonCart = this.props.options && this.props.options.isCommonCart;
        var titleEditLabel;
        var titleRemoveLabel;
        if (this.props && this.props.options && this.props.options.planType) {
            if (this.props.options.planType === CartViewPanelProps_1.PlanType.BROADBAND) {
                titleEditLabel = 'Edit Internet';
                titleRemoveLabel = 'Remove Internet';
            }
            else if (this.props.options.planType === CartViewPanelProps_1.PlanType.BUSINESS_TOOLS) {
                titleEditLabel = 'Edit Business Tools';
                titleRemoveLabel = 'Remove Business Tools';
            }
            else {
                titleEditLabel = 'Edit cart';
                titleRemoveLabel = 'Remove cart';
            }
        }
        var editLabel = (React.createElement("div", null,
            React.createElement(components_1.Link, { kind: "withPrependIcon", testId: utils_1.default(this.props.testId, 'Link', 'EditPlan'), icon: React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: Utils.GET_ICON_SVG.PEN }), onClick: this.props.events.onEdit, "aria-label": this.EditText + this.props.data.lineOfBusinessName, role: "link", className: CartConfiguration_scss_1.cartLinkMedium, title: titleEditLabel })));
        var removeLabel = (React.createElement("div", null,
            React.createElement(components_1.Link, { kind: "withPrependIcon", testId: utils_1.default(this.props.testId, 'Link', 'Remove'), onClick: this.openRemoveItemModal, "aria-label": (this.RemoveText + this.props.data.removeItemsLinkLabel), className: CartConfiguration_scss_1.cartLinkMedium, icon: React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: Utils.GET_ICON_SVG.TRASH }), title: titleRemoveLabel })));
        return (React.createElement("div", { "data-test-id": this.props.testId },
            React.createElement("div", { className: ((_a = this.props) === null || _a === void 0 ? void 0 : _a.tvLaterBBExperience) ? styles.tvLaterExperience :
                    (this.props.options && this.props.options.showAccordions &&
                        this.state.isBundleCart ? [styles.cvTitleContainer, styles.cursorPointer].join(' ') :
                        styles.cvTitleContainer), onClick: this.props.options && this.props.options.showAccordions &&
                    this.state.isBundleCart ? this.handleClick : undefined },
                React.createElement("div", { className: styles.cartIconImgstyle },
                    this.props.options.planType === 'accessories' &&
                        React.createElement("div", { className: styles.planIconAcc },
                            React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": this.ariaLabelContent })),
                    this.props.options.planType !== 'accessories' &&
                        this.props.options.planType !== CartViewPanelProps_1.PlanType.BUSINESS_TOOLS &&
                        React.createElement("div", { className: styles.planIcon },
                            React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": this.ariaLabelContent })),
                    this.props.options.planType === CartViewPanelProps_1.PlanType.BUSINESS_TOOLS &&
                        React.createElement("div", { className: styles.planIconBus },
                            React.createElement("img", { className: iconClasses.join(' '), src: imageUrl, alt: 'business tool logo' }))),
                React.createElement("div", { className: styles.cartTitleExpandcollapse },
                    React.createElement("div", { className: [styles.pRight25px, styles.floatL].join(' ') },
                        React.createElement("h2", { className: styles.lobTitle, dangerouslySetInnerHTML: {
                                __html: this.props.data.lineOfBusinessName,
                            } })),
                    this.props.options && this.props.options.showAccordions && this.state.isBundleCart &&
                        React.createElement("i", { className: [icons.cccIconCart,
                                !this.state.accordianOpen ? icons.cccIconCartAddMaximize : icons.cccIconCartSubtractminimize,
                                styles.iconExpandCollapse].join(' '), role: "img", "aria-label": (!this.state.accordianOpen ? this.ExpandText : this.CollapseText) +
                                this.props.data.lineOfBusinessName }),
                    this.props.options && !this.props.options.hideEditAndRemove && !this.props.options.showAccordions &&
                        React.createElement("div", { className: styles.editremoveBtn },
                            this.props.options && this.props.options.externalOrderSource !== 'BMWSMART'
                                && this.props.options.planType !== CartViewPanelProps_1.PlanType.HBOMAX && !this.isCommonCart &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("span", null,
                                        " ",
                                        !isFBmarketing && editLabel),
                                    displayRemoveLink && !isFBmarketing && React.createElement("span", { className: CartConfiguration_scss_1.cartPipeSeparator })),
                            displayRemoveLink && React.createElement("span", null, removeLabel))),
                React.createElement("div", { className: styles.clearFix })),
            this.state.accordianOpen && (this.props.options.planType !== CartViewPanelProps_1.PlanType.BUSINESS_TOOLS) &&
                !((_b = this.props) === null || _b === void 0 ? void 0 : _b.tvLaterBBExperience) &&
                React.createElement("div", { className: styles.containerWidth },
                    React.createElement("div", { className: styles.lineItems }, this.props.children),
                    React.createElement("div", { className: styles.duePrices },
                        this.props.options && this.props.options.externalOrderSource && this.externalOrderSourceDueView(),
                        this.props.options && !this.props.options.externalOrderSource && this.bauDueView()),
                    this.props.options && !this.props.options.hideEditAndRemove && this.props.options.showAccordions &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.solidLineLightGray }),
                            React.createElement("div", { className: [styles.lineItems, styles.removeAll].join(' ') },
                                this.props.options && this.props.options.planType !== CartViewPanelProps_1.PlanType.HBOMAX && !isFBmarketing &&
                                    React.createElement("span", null,
                                        React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartPen, styles.linkWithIcon].join(' '), role: "img", "aria-label": this.EditText + this.props.data.lineOfBusinessName }),
                                        editLabel),
                                this.props.options.isRemoveAllButtonApplicable &&
                                    React.createElement("span", null,
                                        !isFBmarketing && React.createElement("span", { className: styles.seperaterLine }),
                                        React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartTrash, styles.linkWithIcon].join(' '), role: "img", "aria-label": this.props.data.removeItemsLinkLabel }),
                                        removeLabel)))),
            !this.state.accordianOpen && React.createElement("div", { className: styles.fullSolidLine })));
    };
    CartViewPanel.prototype.bauDueView = function () {
        return (React.createElement(React.Fragment, null,
            this.props.options && this.props.options.newSavingPromoPanel &&
                React.createElement("div", { className: styles.dueLineItem },
                    React.createElement("div", { className: styles.solidlineGrey }),
                    React.createElement("div", { className: styles.orderTotals }, " Order totals ")),
            this.props.data && !this.props.data.hideDueTodayPrice && this.getDueTodayView(this.pricingType),
            this.getDuePriceView(this.props.options, this.pricingType),
            this.props.options.isPromoTextApplicable &&
                React.createElement("div", { className: styles.lineItems },
                    React.createElement(ui_components_1.Label, { testId: utils_1.default(this.props.testId, 'Label', 'PromoText'), data: { text: "" + this.props.options.commonPromotionText }, options: { className: styles.promoText } }))));
    };
    CartViewPanel.prototype.dueOnFirstBillSection = function (pricingType, showLegalLink) {
        return (React.createElement("div", { className: styles.dueLineItems },
            React.createElement("div", { className: styles.dueItemName },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'DueOnFirstBill'), data: { text: this.props.data.dueOneTimeLabel ? this.props.data.dueOneTimeLabel : 'Due only on first bill*' } }),
                showLegalLink && this.dueTodayModalLegalObj.showLegal &&
                    !(this.props.options && (this.props.options.hidedueTodaySeeDetails || this.isCommonCart)) &&
                    this.getDueTodayModal()),
            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueOnFirstBillPrice'), data: { billingNote: '', price: (this.props.data.due1stBillPrice ? this.props.data.due1stBillPrice : 0) }, options: { type: pricingType, className: styles.dueItemPrice, decimalPoints: 2 } })));
    };
    CartViewPanel.prototype.externalOrderSourceDueView = function () {
        if (this.props.options && this.props.options.externalOrderSource) {
            return (React.createElement("div", null,
                React.createElement("div", { className: styles.solidLineLightGray }),
                this.dueMonthlySection(this.pricingType, false),
                this.dueOnFirstBillSection(this.pricingType, false),
                React.createElement("div", { className: [styles.commonLegal, styles.p0top].join(' ') },
                    React.createElement("span", null, this.props.options.commonCartLegalLabel ? this.props.options.commonCartLegalLabel :
                        "*Plus add'l taxes and fees. Amounts shown are for this order only and don't include current account charges."),
                    React.createElement("span", null, this.showExpUpLegalContent()))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartViewPanel.prototype.getIconFromOps = function (options) {
        if (options.planType === CartViewPanelProps_1.PlanType.WIRELESS || options.planType === CartViewPanelProps_1.PlanType.WIRELESS_CRP
            || options.planType === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID) {
            return [icons.cccIconCartMobilesmartphoneL, styles.wirelessCartIcon];
        }
        else if (options.planType === CartViewPanelProps_1.PlanType.BROADBAND
            || options.planType === CartViewPanelProps_1.PlanType.BUSINESS_TOOLS) {
            return [icons.cccIconCartInternetL, styles.broadbandCartIcon];
        }
        else if (options.planType === CartViewPanelProps_1.PlanType.ACCESSORIES) {
            return [icons.cccIconCartAccessoriesL, styles.accessoriesCartIcon];
        }
        return [];
    };
    CartViewPanel.prototype.handleClick = function () {
        this.setState({ accordianOpen: !this.state.accordianOpen });
    };
    CartViewPanel.prototype.getDuePriceView = function (options, pricingType) {
        if (options.planType === CartViewPanelProps_1.PlanType.WIRELESS_CRP ||
            options.planType === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID) {
            return this.getDTVNOWandCRP_View(pricingType);
        }
        else if (options.planType === CartViewPanelProps_1.PlanType.WIRELESS
            || options.planType === CartViewPanelProps_1.PlanType.BROADBAND) {
            return this.getDTVS_WIRELESS_CartView(pricingType);
        }
        return (React.createElement(React.Fragment, null));
    };
    CartViewPanel.prototype.getDTVNOWandCRP_View = function (pricingType) {
        return (React.createElement("span", null,
            React.createElement("div", { className: styles.dueLineItems },
                React.createElement("div", { className: styles.dueItemName },
                    React.createElement(ui_components_1.RichText, { data: { text: this.getMonthlyText() } }),
                    this.dueMonthlyModalLegalObj.showLegal &&
                        React.createElement(React.Fragment, null,
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(this.props.testId, 'Link', 'DueMonthly'), className: [styles.detailsLink, styles.legalLinkSpace].join(' '), onClick: this.openDueMonthlyModal }, this.dueMonthlyModalLegalObj.shortdesclinktext || 'See details'),
                            React.createElement(ui_components_1.Modal, { testId: "_Due_Monthly_Details", options: {
                                    center: true,
                                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                                    show: this.state.dueMonthlyModalDisplayed,
                                    showClose: true,
                                    size: ModalProps_1.ModalSizes.MEDIUM,
                                    tabIndex: 0,
                                }, events: { onClose: this.closeDueMonthlyModal } },
                                React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                                    React.createElement(ui_components_1.Label, { data: { text: this.dueMonthlyModalLegalObj.modaltitle }, options: { className: CartConfiguration_scss_1.rennyModalTitle } }),
                                    React.createElement("p", { className: [(this.eapFlowContext && this.eapFlowContext.isEAPFlow &&
                                                this.props.options && this.props.options.hideEditAndRemove) ?
                                                styles.disableLink : ''].join(' '), dangerouslySetInnerHTML: {
                                            __html: this.dueMonthlyModalLegalObj.longtext,
                                        } }))))),
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueMonthlyPrice'), data: { billingNote: '', price: (this.props.data.dueMonthlyPrice ? this.props.data.dueMonthlyPrice : 0) }, options: { type: pricingType, className: styles.dueItemPrice, decimalPoints: 2 } })),
            this.props && this.props.options && this.props.options.planType === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID &&
                this.props.options.isPrepaidMonthlyPlan &&
                React.createElement(ui_components_1.Label, { testId: utils_1.default(this.props.testId, 'Label', 'Prepaid_Plan_AutoPay'), data: { text: this.props.data.autopayPlanLabel }, options: { className: styles.prepaidAutopayLabel } })));
    };
    CartViewPanel.prototype.getDTVS_WIRELESS_CartView = function (pricingTypee) {
        var _a, _b;
        var pricingType = PriceContainerProps_1.PricingType.TILE;
        var subtotal = parseFloat('' + (this.props.data.due1stBillPrice ? this.props.data.due1stBillPrice : 0))
            + parseFloat('' + (this.props.data.dueMonthlyPrice ? this.props.data.dueMonthlyPrice : 0));
        if (this.isCommonCart) {
            return (React.createElement("div", null,
                this.dueMonthlySection(pricingTypee, true),
                ((_b = (_a = this.props.options) === null || _a === void 0 ? void 0 : _a.zipCodeEdit) === null || _b === void 0 ? void 0 : _b.displayTaxZip) &&
                    React.createElement("div", { className: styles.dueLineItem },
                        React.createElement(CartZipEdit_1.default, { data: {
                                displayTaxZip: this.props.options.zipCodeEdit.displayTaxZip,
                                isCommonCart: this.isCommonCart,
                                isEditable: this.props.options.zipCodeEdit.isEditable,
                                zipCode: this.props.options.zipCodeEdit.zipCode,
                                zipDisplayContent: this.props.options.zipCodeEdit.zipDisplayContent,
                                zipErrorContent: this.props.options.zipCodeEdit.zipErrorContent,
                                zipUpdateButtonContent: this.props.options.zipCodeEdit.zipUpdateButtonContent,
                            } })),
                React.createElement("div", { className: this.isCommonCart ? [CartCommonStyle.commonContentSmall, styles.legalContainer].join(' ')
                        : styles.commonLegal },
                    React.createElement("span", null, this.props.options.commonCartLegalLabel ? this.props.options.commonCartLegalLabel : '*Includes estimated taxes and fees.'),
                    React.createElement("span", null, this.showExpUpLegalContent()))));
        }
        else {
            return (React.createElement("span", null,
                this.props.data.lineOfBusinessName === 'WIRELESS' &&
                    React.createElement("div", { className: styles.solidLineLightGray }),
                React.createElement("div", { className: styles.dueLineItems },
                    React.createElement("div", { className: styles.dueItemName },
                        React.createElement("h3", { id: utils_1.default(this.props.testId, 'Label', 'Due on 1st billcc'), className: styles.legalHeading }, this.due1stBillModalLegalObj.shorttext ?
                            this.due1stBillModalLegalObj.shorttext : 'Due on 1st bill'),
                        this.due1stBillModalLegalObj.showLegal &&
                            React.createElement(React.Fragment, null,
                                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(this.props.testId, 'Link', '1stBill'), className: [styles.detailsLink, styles.legalLinkSpace].join(' '), onClick: this.openDue1stBillModal }, this.due1stBillModalLegalObj.shortdesclinktext || 'See details'),
                                React.createElement(ui_components_1.Modal, { testId: "_First_Bill_Details", options: {
                                        center: true,
                                        className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                                        show: this.state.due1stBillModalDisplayed,
                                        showClose: true,
                                        size: ModalProps_1.ModalSizes.MEDIUM,
                                        tabIndex: 0,
                                    }, events: { onClose: this.closeDue1stBillModal } },
                                    React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                                        React.createElement(ui_components_1.Label, { data: { text: this.due1stBillModalLegalObj.modaltitle }, options: { className: CartConfiguration_scss_1.rennyModalTitle } }),
                                        React.createElement("p", { className: [(this.eapFlowContext && this.eapFlowContext.isEAPFlow &&
                                                    this.props.options && this.props.options.hideEditAndRemove) ?
                                                    styles.disableLink : ''].join(' '), dangerouslySetInnerHTML: {
                                                __html: this.due1stBillModalLegalObj.longtext,
                                            } })))))),
                React.createElement("div", { className: styles.dueFirstbillLineItems },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'MonthlyChargess'), data: { text: this.props.data.dueMonthlyLabel ? this.props.data.dueMonthlyLabel : 'Monthly charges' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueMonthlyPrice'), data: { billingNote: '', price: (this.props.data.dueMonthlyPrice ? this.props.data.dueMonthlyPrice : 0) }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                React.createElement("div", { className: styles.dueFirstbillLineItems },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'OneTimeCharges'), data: { text: this.props.data.dueOneTimeLabel ? this.props.data.dueOneTimeLabel : 'One-time charges' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', '1stBillPrice'), data: { billingNote: '', price: (this.props.data.due1stBillPrice ? this.props.data.due1stBillPrice : 0) }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                React.createElement("div", { className: [styles.savingsLineItem, styles.dueFirstbillLineItems].join(' ') },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'Subtotals'), data: { text: this.props.data.dueSubTotalLabel ? this.props.data.dueSubTotalLabel : 'Subtotal' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'Subtotal'), data: { billingNote: '', price: (subtotal ? subtotal : 0) }, options: { type: pricingTypee, className: styles.dueItemPrice, decimalPoints: 2 } }))));
        }
    };
    CartViewPanel.prototype.getLegalContent = function (legalAEMUrl, legalContent, legaltype) {
        var _this = this;
        if (legalAEMUrl) {
            cartUtils.getLegalIDPData(legalAEMUrl, legalContent, legalContent.longtext, legalContent.shorttext).then(function (response) {
                if (response.shortdesclinktext) {
                    legalContent.shortdesclinktext = response.shortdesclinktext;
                    if (response.longtext) {
                        legalContent.longtext = response.longtext;
                        legalContent.showLegal = true;
                        _this.setDataForBundle(_this.props.options.planType, legalAEMUrl, response, legaltype);
                    }
                }
                if (response.shorttext) {
                    legalContent.shorttext = response.shorttext;
                }
                if (response.modaltitle) {
                    legalContent.modaltitle = response.modaltitle;
                }
                _this.setState({ legalContenFound: true });
            }).catch(function (err) {
                legalContent.showLegal = false;
                _this.setState({ legalContenFound: false });
            });
        }
    };
    CartViewPanel.prototype.getLegalIDPContent = function (legalAEMUrl, legalContent, legaltype, linktext, shortdesc) {
        var _this = this;
        cartUtils.getLegalIDPData(legalAEMUrl, legalContent, linktext, shortdesc).then(function (legalobj) {
            legalContent = legalobj;
            if (legalContent && legalContent.showLegal) {
                _this.setDataForBundle(_this.props.options.planType, legalAEMUrl, legalContent, legaltype, linktext);
                _this.setState({ legalContenFound: true });
            }
            else {
                _this.setState({ legalContenFound: false });
            }
        });
    };
    CartViewPanel.prototype.getDueTodayView = function (pricingType) {
        if (this.props.data.earlyUpgradeAmount && this.props.data.earlyUpgradeAmount > 0) {
            this.isEarlyUpgrade = true;
        }
        else {
            this.isEarlyUpgrade = false;
        }
        var isPrePreOrder = cartUtils.isPrePreOrder();
        var dueTodayText = '';
        if (isPrePreOrder) {
            dueTodayText = 'Due at purchase';
        }
        else if (this.isCommonCart) {
            dueTodayText = 'Due today*';
        }
        else if (this.dueTodayModalLegalObj && this.dueTodayModalLegalObj.shorttext) {
            dueTodayText = this.dueTodayModalLegalObj.shorttext;
        }
        else {
            dueTodayText = 'Due today';
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                React.createElement("div", { className: styles.solidLineLightGray }),
                cartUtils.enableBillComponent() &&
                    React.createElement("div", { className: styles.billestimatorMessage },
                        React.createElement("strong", null, this.props.options.billEstimatorHeading),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        this.props.options.billEstimatorMessage),
                React.createElement("div", { className: styles.dueLineItems },
                    React.createElement("div", { className: styles.dueItemName },
                        React.createElement("h3", { id: utils_1.default(this.props.testId, 'Label', 'DueTodayView'), className: styles.legalHeading }, dueTodayText),
                        this.dueTodayModalLegalObj.showLegal &&
                            !(this.props.options && (this.props.options.hidedueTodaySeeDetails || this.isCommonCart)) &&
                            this.getDueTodayModal()),
                    !this.isEarlyUpgrade &&
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'TodayPrice'), data: { billingNote: '', price: (this.props.data.dueTodayPrice ? this.props.data.dueTodayPrice : 0) }, options: { type: pricingType, className: styles.dueItemPrice, decimalPoints: 2 } }))),
            this.isEarlyUpgrade && this.getDueTodaySubSecView(),
            this.props.options && this.props.options.zipCodeEdit && this.props.options.zipCodeEdit.displayTaxZip &&
                !this.isCommonCart &&
                React.createElement("div", { className: styles.dueLineItem },
                    React.createElement(CartZipEdit_1.default, { data: {
                            displayTaxZip: this.props.options.zipCodeEdit.displayTaxZip,
                            isEditable: this.props.options.zipCodeEdit.isEditable,
                            zipCode: this.props.options.zipCodeEdit.zipCode,
                            zipDisplayContent: this.props.options.zipCodeEdit.zipDisplayContent,
                            zipErrorContent: this.props.options.zipCodeEdit.zipErrorContent,
                            zipUpdateButtonContent: this.props.options.zipCodeEdit.zipUpdateButtonContent,
                        } })),
            this.isCommonCart && this.dueTodaySubSection()));
    };
    CartViewPanel.prototype.setDataForBundle = function (lobname, legalurl, legalresp, legaltype, linktext) {
        var _a;
        var lobType = lobname || 'default';
        var legalData = {
            longtext: legalresp.longtext,
            modaltitle: legalresp.modaltitle,
            shortdesclinktext: linktext ? linktext : legalresp.shortdesclinktext,
        };
        var lobLegalContent = (_a = {}, _a[lobType] = { url: legalurl, legalData: legalData }, _a);
        var legalSessionObj = 'bundLelegal' + legaltype;
        var allLob = this.stateManager.get('CART', legalSessionObj);
        if (allLob) {
            var combined = Object.assign(allLob, lobLegalContent);
            this.stateManager.set(legalSessionObj, combined);
        }
        else {
            this.stateManager.set(legalSessionObj, lobLegalContent);
        }
    };
    CartViewPanel.prototype.getDueTodaySubSecView = function () {
        var pricingType = (window.innerWidth < 768) ? PriceContainerProps_1.PricingType.XSMALL : PriceContainerProps_1.PricingType.SMALL;
        if (this.isEarlyUpgrade) {
            var subtotal = Number(this.props.data.earlyUpgradeAmount) + Number(this.props.data.newCartItemsAmount);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.dueFirstbillLineItems },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'UpgradeEarly'), data: { text: this.props.data.wirelessUpgradeDisplayName } }),
                        this.props.data.upgradeOptionTypeTooltipTxt &&
                            React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: this.props.data.upgradeOptionTypeTooltipTxt } }), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                                React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION }))),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'UpgradeEarlyAmmout'), data: { billingNote: '', price: this.props.data.earlyUpgradeAmount }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                React.createElement("div", { className: styles.dueFirstbillLineItems },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'NewCartItems'), data: { text: 'New cart items' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'NewCartItemsAmount'), data: { billingNote: '', price: this.props.data.newCartItemsAmount }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                React.createElement("div", { className: [styles.dueItemPrice, styles.dueFirstbillLineItems].join(' ') },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'DueTodaySubtotals'), data: { text: 'Subtotal' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueTodaySubtotalAmount'), data: { billingNote: '', price: subtotal }, options: { type: pricingType, className: styles.dueItemPrice, decimalPoints: 2 } }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartViewPanel.prototype.getDueTodayModal = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(this.props.testId, 'Link', 'DueToday'), className: [styles.detailsLink, styles.legalLinkSpace].join(' '), onClick: this.openDueTodayModal }, this.dueTodayModalLegalObj.shortdesclinktext || 'See details'),
            React.createElement(ui_components_1.Modal, { testId: "_Due_Today_Details", options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.dueTodayModalDisplayed,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                    tabIndex: 0,
                }, events: { onClose: this.closeDueTodayModal } },
                React.createElement("div", { className: CartCommonStyle.commonModalContainer },
                    React.createElement(ui_components_1.Label, { data: { text: this.dueTodayModalLegalObj.modaltitle }, options: { className: CartConfiguration_scss_1.rennyModalTitle } }),
                    React.createElement("br", null),
                    React.createElement("div", { className: [CartCommonStyle.commonLegalContent, styles.mTop10].join(' ') },
                        React.createElement("p", { className: [(this.eapFlowContext && this.eapFlowContext.isEAPFlow &&
                                    this.props.options && this.props.options.hideEditAndRemove) ?
                                    styles.disableLink : ''].join(' '), dangerouslySetInnerHTML: {
                                __html: this.dueTodayModalLegalObj.longtext,
                            } }))))));
    };
    CartViewPanel.prototype.dueTodaySubSection = function () {
        var pricingType = PriceContainerProps_1.PricingType.TILE;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.dueItemsContainer },
                React.createElement("div", { className: styles.bsseDueItems },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'MonthlyChargess'), data: { text: this.props.data.dueTodayMonthlyLabel ? this.props.data.dueTodayMonthlyLabel : 'Monthly charges' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueMonthlyPrice'), data: { billingNote: '', price: (this.props.data.dueTodayFirstMonth ?
                                this.props.data.dueTodayFirstMonth : 0) }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                this.props.data && this.props.data.bsseServicePeriodLabel &&
                    React.createElement("div", { className: styles.container85w },
                        React.createElement(ui_components_1.Label, { data: { text: this.props.data.bsseServicePeriodLabel }, options: { className: CartCommonStyle.commonContentSmall } }))),
            React.createElement("div", { className: [styles.dueItemsContainer, styles.mTop10].join(' ') },
                React.createElement("div", { className: styles.bsseDueItems },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'OneTimeCharges'), data: { text: this.props.data.dueOneTimeLabel ? this.props.data.dueOneTimeLabel : 'One-time charges' } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'dueTodayOneTime'), data: { billingNote: '', price: (this.props.data.dueTodayOneTime ? this.props.data.dueTodayOneTime : 0) }, options: { type: pricingType, className: styles.cartSubtotalAttMedium, decimalPoints: 2 } })),
                this.props.data && this.props.data.bsseIncludeTaxLabel &&
                    React.createElement(ui_components_1.Label, { data: { text: this.props.data.bsseIncludeTaxLabel }, options: { className: [CartCommonStyle.commonContentSmall, styles.container85w].join(' ') } })),
            this.props.data && this.props.data.oneTimeCreditAmount !== 0 &&
                React.createElement("div", { className: [styles.dueItemsContainer, styles.mTop10].join(' ') },
                    React.createElement("div", { className: styles.bsseDueItems },
                        React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'OneTimeCreditLabel'), data: { text: this.props.data.dueOneTimeCreditLabel ?
                                    this.props.data.dueOneTimeCreditLabel : 'One-time credit for current line(s)' } }),
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'oneTimeCreditAmount'), data: { billingNote: '', price: Math.abs(this.props.data.oneTimeCreditAmount) }, options: { className: styles.cartSubtotalAttMedium, decimalPoints: 2,
                                isDataPriceNegative: this.props.data.oneTimeCreditAmount < 0 ? true : false, type: pricingType } })),
                    this.props.data && this.props.data.dueOneTimeCreditSubLabel &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: [styles.container85w, styles.lineSmall].join(' ') },
                                React.createElement("span", { className: CartCommonStyle.commonContentSmall }, this.props.data.dueOneTimeCreditSubLabel),
                                this.isCommonCart && this.props.options && this.props.options.monthlySavings &&
                                    React.createElement("span", null,
                                        React.createElement(MonthlySavings_1.default, { data: { monthlySavings: this.props.options.monthlySavings, showMonthlySaving: true,
                                                showOnlyLink: true } })))))));
    };
    CartViewPanel.prototype.showBsseSavingsModal = function () {
        // Implementation in next sprint
    };
    CartViewPanel.prototype.dueMonthlySection = function (pricingType, showLegalLink) {
        return (React.createElement("div", { className: styles.dueLineItems },
            React.createElement("div", { className: styles.dueItemName },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default(this.props.testId, 'Label', 'DueMonthly'), data: { text: this.props.data.dueMonthlyLabel ? this.props.data.dueMonthlyLabel : 'Due monthly*' } }),
                showLegalLink && this.dueTodayModalLegalObj.showLegal &&
                    !(this.props.options && (this.props.options.hidedueTodaySeeDetails || this.isCommonCart)) &&
                    this.getDueTodayModal()),
            !this.isEarlyUpgrade &&
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default(this.props.testId, 'Label', 'DueMonthlyPrice'), data: { billingNote: '', price: (this.props.data.dueMonthlyPrice ? this.props.data.dueMonthlyPrice : 0) }, options: { type: pricingType, className: styles.dueItemPrice, decimalPoints: 2 } })));
    };
    CartViewPanel.prototype.showExpUpLegalContent = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var linkText = '';
        var externalOrderSource = false;
        if (this.props.options && this.props.options.externalOrderSource) {
            linkText = (_b = (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.due1stBillModalLegalContents) === null || _b === void 0 ? void 0 : _b.legallinkText;
            externalOrderSource = true;
        }
        else {
            linkText = ((_d = (_c = this.props.data) === null || _c === void 0 ? void 0 : _c.dueTodayModalLegalContents) === null || _d === void 0 ? void 0 : _d.legallinkText) || ((_f = (_e = this.props.data) === null || _e === void 0 ? void 0 : _e.due1stBillModalLegalContents) === null || _f === void 0 ? void 0 : _f.legallinkText);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('commonCartSeeDetailsLink', 'legalmodal'), className: styles.commonCartLegallink, 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.handleCommonCartModal(true, linkText);
                    _this.setState({ showCommonLegal: true });
                } }, linkText),
            React.createElement(ui_components_1.Modal, { testId: "CommonCart_Modal_Details", options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showCommonLegal,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                    tabIndex: 0,
                }, events: { onClose: function () {
                        _this.handleCommonCartModal(false, 'Close');
                        _this.setState({ showCommonLegal: false });
                    },
                } },
                React.createElement("div", { className: styles.legalContainer },
                    React.createElement("div", { className: CartConfiguration_scss_1.mb10 },
                        React.createElement(ui_components_1.Label, { data: { text: 'The legal stuff' }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } })),
                    !externalOrderSource && this.dueTodayModalLegalObj.showLegal &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.dueTodayModalLegalObj.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.dueTodayModalLegalObj.longtext } }),
                            React.createElement("br", null)),
                    !externalOrderSource && this.dueMonthlyModalLegalObj.showLegal &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.dueMonthlyModalLegalObj.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.dueMonthlyModalLegalObj.longtext } })),
                    externalOrderSource &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.due1stBillModalLegalObj.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.due1stBillModalLegalObj.longtext } }))))));
    };
    CartViewPanel.defaultProps = {
        options: {
            commonPromotionText: null,
            isPromoTextApplicable: false,
            isRemoveAllButtonApplicable: true,
            isTaxApplied: false,
            planType: CartViewPanelProps_1.PlanType.BROADBAND,
            showAccordions: false,
        },
    };
    return CartViewPanel;
}(React.Component));
exports.default = CartViewPanel;
//# sourceMappingURL=CartViewPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/CartViewPanel/CartViewPanel.js
// module id = 2251
// module chunks = 8